"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdscripcionBulkResponseSchema = exports.AdscripcionBulkSchema = exports.AdscripcionAdminListResponseSchema = exports.AdscripcionAdminItemSchema = exports.RenovarLineasResponseSchema = exports.RenovarLineaResultadoSchema = exports.DerogarLineasResponseSchema = exports.LineaRechazoSchema = exports.LineasBulkIdsSchema = exports.EditarLineaSchema = exports.CrearLineaSchema = exports.LineaAdminListResponseSchema = exports.LineaAdminItemSchema = void 0;
const zod_1 = require("zod");
// ───────────── Admin lines & subscriptions management (R55) ─────────────
//
// Request/response contracts for `/admin/lineas` (research lines,
// `linea_investigacion`) and its center-subscriptions axis (`lineas_centro`).
// `estado`/vigencia are computed with `resolveEstadoLinea`/`esAdscripcionVigente`
// from `./linea-vigencia` — never re-derived here.
//
// This is the CONTRACT layer only (Foundation, R55 Phase 1). The API module
// that implements these endpoints (apps/api/src/lineas/) is a later phase.
const LineaUnidadSchema = zod_1.z.object({
    idUnidad: zod_1.z.number().int().positive(),
    nombreUnidad: zod_1.z.string(),
});
const EstadoLineaSchema = zod_1.z.enum(['vigente', 'programada', 'derogada']);
// ───────────── Line list (read) ─────────────
exports.LineaAdminItemSchema = zod_1.z.object({
    idLinea: zod_1.z.number().int().positive(),
    nombreLinea: zod_1.z.string(),
    // null = transversal (id_unidad IS NULL) — the client MUST show an explicit
    // indicator, never a blank cell.
    unidad: LineaUnidadSchema.nullable(),
    fechaCreacion: zod_1.z.string(),
    fechaDerogacion: zod_1.z.string().nullable(),
    estado: EstadoLineaSchema,
    // Distinct currently-valid subscribing centers (esAdscripcionVigente), never deduped away.
    adscripcionesVigentes: zod_1.z.number().int().nonnegative(),
    // investigador_linea rows with fechaTraslado IS NULL — read-only, informational.
    investigadoresActivos: zod_1.z.number().int().nonnegative(),
});
exports.LineaAdminListResponseSchema = zod_1.z.array(exports.LineaAdminItemSchema);
// ───────────── Line create / edit ─────────────
exports.CrearLineaSchema = zod_1.z.object({
    nombreLinea: zod_1.z.string().min(1).max(1000),
    // Omitted or null = transversal line.
    idUnidad: zod_1.z.number().int().positive().nullable().optional(),
    // Defaults to submission date server-side when omitted.
    fechaCreacion: zod_1.z.string().date().optional(),
    // SHOULD default to fechaCreacion + 2 years server-side when omitted.
    fechaDerogacion: zod_1.z.string().date().optional(),
});
// `.strict()` on purpose: editing MUST NOT smuggle a validity-date change —
// fechaCreacion/fechaDerogacion transitions are exclusive to renovar/derogar.
// An unrecognized key (including those two) fails Zod parsing at the boundary.
exports.EditarLineaSchema = zod_1.z
    .object({
    nombreLinea: zod_1.z.string().min(1).max(1000).optional(),
    idUnidad: zod_1.z.number().int().positive().nullable().optional(),
})
    .strict();
// ───────────── Line bulk actions (derogar / renovar) ─────────────
exports.LineasBulkIdsSchema = zod_1.z.object({
    idLineas: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
// Per-row rejection reported by a bulk action's pre-flight validation (ADR-4):
// any row failing eligibility blocks the WHOLE batch — nothing commits.
exports.LineaRechazoSchema = zod_1.z.object({
    idLinea: zod_1.z.number().int().positive(),
    motivo: zod_1.z.string(),
});
exports.DerogarLineasResponseSchema = zod_1.z.object({
    afectadas: zod_1.z.number().int().nonnegative(),
    adscripcionesExpiradas: zod_1.z.number().int().nonnegative(),
});
exports.RenovarLineaResultadoSchema = zod_1.z.object({
    idLinea: zod_1.z.number().int().positive(),
    fechaDerogacion: zod_1.z.string(),
});
exports.RenovarLineasResponseSchema = zod_1.z.object({
    afectadas: zod_1.z.number().int().nonnegative(),
    nuevaFechaPorLinea: zod_1.z.array(exports.RenovarLineaResultadoSchema),
});
// ───────────── Center subscriptions (lineas_centro) — list ─────────────
exports.AdscripcionAdminItemSchema = zod_1.z.object({
    idCentro: zod_1.z.number().int().positive(),
    nombreCentro: zod_1.z.string(),
    idLinea: zod_1.z.number().int().positive(),
    nombreLinea: zod_1.z.string(),
    fechaAdscripcion: zod_1.z.string(),
    fechaExpiracion: zod_1.z.string().nullable(),
    vigente: zod_1.z.boolean(),
});
// One row per (center, line) — a line held by multiple centers renders as
// multiple rows here, never deduped (unlike LineaAdminItemSchema's list).
exports.AdscripcionAdminListResponseSchema = zod_1.z.array(exports.AdscripcionAdminItemSchema);
// ───────────── Center subscriptions — bulk actions (adscribir / expirar) ─────────────
exports.AdscripcionBulkSchema = zod_1.z.object({
    idCentro: zod_1.z.number().int().positive(),
    idLineas: zod_1.z.array(zod_1.z.number().int().positive()).min(1),
});
exports.AdscripcionBulkResponseSchema = zod_1.z.object({
    afectadas: zod_1.z.number().int().nonnegative(),
});
